import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CriarGrupoDto } from '@/types/grupo/grupoTypes';

import { gruposAdminService } from './services';

export const fetchGrupos = createAsyncThunk(
  'gruposAdmin/fetch',
  async (_arg, { rejectWithValue }) => {
    try {
      return await gruposAdminService.listar();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const criarGrupo = createAsyncThunk(
  'gruposAdmin/criar',
  async (data: CriarGrupoDto, { rejectWithValue }) => {
    try {
      return await gruposAdminService.criar(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const vincularEscritorio = createAsyncThunk(
  'gruposAdmin/vincular',
  async (
    { grupoId, escritorioFilhoId }: { grupoId: string; escritorioFilhoId: string },
    { rejectWithValue },
  ) => {
    try {
      return await gruposAdminService.vincular(grupoId, escritorioFilhoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const desvincularEscritorio = createAsyncThunk(
  'gruposAdmin/desvincular',
  async (
    { grupoId, escritorioId }: { grupoId: string; escritorioId: string },
    { rejectWithValue },
  ) => {
    try {
      return await gruposAdminService.desvincular(grupoId, escritorioId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchConsolidado = createAsyncThunk(
  'gruposAdmin/consolidado',
  async (grupoId: string, { rejectWithValue }) => {
    try {
      return await gruposAdminService.consolidado(grupoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
